import { fetcher } from '@commenda/utils';
import {
  ExportTaxBreakdownForFilingsWithinDateRangeRequest,
  ExportTaxBreakdownsRequest,
  ExportTaxBreakdownsResponse,
} from './types';

export async function exportTaxBreakdowns(
  exportTaxBreakdownsRequest: ExportTaxBreakdownsRequest
): Promise<{
  success: boolean;
  error?: string;
  data?: ExportTaxBreakdownsResponse;
}> {
  try {
    const response = await fetcher(
      `new-sales-tax/filings/export/tax-breakdowns`,
      {
        method: 'POST',
        body: exportTaxBreakdownsRequest,
      }
    );

    const data: ExportTaxBreakdownsResponse = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Failed to export tax breakdowns',
      };
    }

    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}

export async function exportTaxBreakdownsWithLineItems(
  exportTaxBreakdownsRequest: ExportTaxBreakdownsRequest
): Promise<{
  success: boolean;
  error?: string;
  data?: ExportTaxBreakdownsResponse;
}> {
  try {
    const response = await fetcher(
      `new-sales-tax/filings/export/tax-breakdowns/line-items`,
      {
        method: 'POST',
        body: exportTaxBreakdownsRequest,
      }
    );

    const data: ExportTaxBreakdownsResponse = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Failed to export tax breakdowns',
      };
    }

    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}

export async function exportTaxBreakdownsForFilingsWithinDateRange(
  exportTaxBreakdownsRequest: ExportTaxBreakdownForFilingsWithinDateRangeRequest
): Promise<{
  success: boolean;
  error?: string;
  data?: ExportTaxBreakdownsResponse;
}> {
  try {
    const response = await fetcher(
      `new-sales-tax/filings/export/tax-breakdowns/by-date-range`,
      {
        method: 'POST',
        body: exportTaxBreakdownsRequest,
      }
    );

    const data: ExportTaxBreakdownsResponse = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Failed to export tax breakdowns',
      };
    }

    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}
